export const registrationTypes = [
  {
    id: "Registered",
    name: "Registered",
  },
  {
    id: "Unregistered",
    name: "Unregistered",
  },
];